import "../scss/groups/_form.scss"

import {ExtendFormie} from './components/ExtendFormie/ExtendFormie.js';

document.addEventListener('onFormieInit', (e) => {
    const Formie = e.detail.formie;
    Formie.forms.forEach(settings => {
        new ExtendFormie( settings )
    })
})

